import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BUTTON_VARIANT, H2 } from '@manulife/mux';
import {
  FormattedRichMessage,
  useCIAMHistory,
  useRealm,
  usePathBuilder,
  useCIAMContextParam,
  ContentPage,
  CoBrandingButton,
  customStyles,
  useRichIntl,
} from 'ciam-self-service-shared';
import handleOtpForAddNumberOrBackupEmailAsyncAction from 'utils/loginAuthnTree/handleOtpForAddNumberOrBackupEmailAsyncActionImpl';
import resendForAddNumberOrBackupEmailAsyncAction from 'utils/loginAuthnTree/resendForAddNumberOrBackupEmailAsyncAction';
import goBackHandlerAsyncAction from 'utils/loginAuthnTree/goBackHandlerAsyncAction';
import useAuthTreeErrorHandler from '../views/authTree/useAuthTreeErrorHandler';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import FormElement from '../../common/FormElement';
import MFAEnterCode from '../../common/MFA/MFAEnterCode';
import userContextUtils from '../../../utils/userContextUtils';
import Page, { AUTH_TYPE } from '../../common/Page';
import { updateAddNumberLoadingStatus, updateGoBackLoadingStatus } from 'components/Login/actions';

const AddMobileVerifyMfa = () => {
  const dispatch = useDispatch();
  const ciamHistory = useCIAMHistory();
  const stage = useSelector((state) => state.loginInfo.stage);
  const otpCount = useSelector((state) => state.loginInfo.otpCount);
  const isOTPGeneratedMultipleTimes = useSelector((state) => state.loginInfo.isOTPGeneratedMultipleTimes);
  const isLoginAfterError = useSelector((state) => state.loginInfo.isLoginAfterError);
  const addNumberLoadingStatus = useSelector((state) => state.loginInfo.addNumberLoadingStatus);
  const goBackLoadingStatus = useSelector((state) => state.loginInfo.goBackLoadingStatus);
  const mobileNumber = useSelector((state) => state.loginInfo.mobileNumber);
  const loginError = useSelector((state) => state.loginInfo.loginError);
  const intl = useRichIntl();
  const realm = useRealm();
  const history = useHistory();
  const pathBuilder = usePathBuilder();
  const brand = useCIAMContextParam('brand');
  const authTreeErrorHandler = useAuthTreeErrorHandler();

  const goBack = async () => {
    const payload = {
      stage,
      history,
      realm,
      brand,
      ciamHistory,
      pathBuilder,
    };
    try {
      dispatch(updateGoBackLoadingStatus(true));
      await goBackHandlerAsyncAction(dispatch, payload);
    } catch (err) {
      authTreeErrorHandler(err);
    } finally {
      dispatch(updateGoBackLoadingStatus(false));
    }
  };

  const handleSubmitCode = async (_, payload) => {
    try {
      dispatch(updateAddNumberLoadingStatus(true));
      await handleOtpForAddNumberOrBackupEmailAsyncAction(dispatch, payload);
    } catch (err) {
      authTreeErrorHandler(err);
    } finally {
      dispatch(updateAddNumberLoadingStatus(false));
    }
  };

  const handleRequestResend = async (_, payload) => {
    try {
      await resendForAddNumberOrBackupEmailAsyncAction(dispatch, payload, 'mobile');
    } catch (err) {
      authTreeErrorHandler(err);
    }
  };

  return (
    <Page title={intl.formatMessage({ id: 'mfa.addNumberMfa.page.title' })} authType={AUTH_TYPE.UNAUTHENTICATED}>
      <ContentPage
        heading={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <FormattedRichMessage
            id="mfa.verifyMobile.enterCode.page.title"
            values={{
              new: isOTPGeneratedMultipleTimes ? intl.formatMessage({ id: `mfa.enterCode.new` }) : '',
            }}
          />
        }
      >
        <MFAEnterCode
          channel={userContextUtils.getChannels({ channelList: ['Mobile'], mobile: mobileNumber })}
          onSubmitCode={handleSubmitCode}
          singleChannel
          stage={stage}
          onRequestResend={handleRequestResend}
          otpCount={otpCount}
          hasResentOtp={isOTPGeneratedMultipleTimes}
          error={loginError}
          isLoginAfterError={isLoginAfterError}
          isLoading={addNumberLoadingStatus}
          header={<FormattedMessage id="mfa.verifyMobile.enterCode.page.title" />}
          content={<FormattedRichMessage id="mfa.verifyMobile.enterCode.timeReminder" values={{ mobileNumber }} />}
          url="/addmobilesuccess"
        />

        <H2>
          <FormattedMessage id="signin.addmobile.verify.didnotgetcode.title" />
        </H2>
        <FormattedRichMessage
          id="signin.addmobile.verify.didnotgetcode.text"
          values={{
            mobileNumber,
          }}
        />

        <FormElement spacing={2}>
          <CoBrandingButton
            variant={BUTTON_VARIANT.SECONDARY}
            customStyle={customStyles.button}
            onClick={goBack}
            analyticsData={{
              click: {
                linkName: intl.formatMessage({ id: 'signin.addmobile.gobackButton' }),
              },
            }}
            disabled={goBackLoadingStatus}
            saving={goBackLoadingStatus}
          >
            <FormattedMessage id="signin.addmobile.gobackButton" />
          </CoBrandingButton>
        </FormElement>
      </ContentPage>
    </Page>
  );
};

export default AddMobileVerifyMfa;
